import React from "react";
import LmsTable from "../ui/LmsTable";
import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { YesNoDropdownOptions } from "../../constants/GlobalConstants";

const LmsVotingRandomizerMainPage = () => {
  const isRandomizerItemActive = (randomizer: { isActive: boolean }) =>
    randomizer.isActive;

  return (
    <LmsTable
      skipClick
      actionButtons={["add", "export"]}
      apiSuffix="/voting/list-randomizers"
      sortable={["Effective Date"]}
      columnLabelsDictionary={{ statusOption: "Randomizer On?" }}
      rowBackgroundColorConditionFunc={isRandomizerItemActive}
      rowBackgroundColor="lightgreen"
      multiline
    />
  );
};

const AddForm = () => {
  const myForm = new BCFormController({}, { submitSuffix: "/voting/add-randomizer" });
  myForm.addCenteredGroup([
    myForm.getCalendarField("Effective Date", { name: "effectiveDate", required: true }),
    myForm.getCheckboxField("Is Active", { value: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getDropdownField("Randomizer On?", YesNoDropdownOptions, { name: "statusOption", required: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getDropdownField("Funds", "/voting/list-randomizer-fund-orgs", {
      dropdownMultiple: true,
      required: true,
      name: "randomizerFundIds",
    }),
  ]);

  myForm.addCenteredGroup([
    myForm.getDropdownField(
      "Funds Assignors",
      "/voting/list-randomizer-fund-assignors",
      {
        required: true,
        dropdownMultiple: true,
        isHiddenOperation: "notequal",
        name: "randomizerFundAssignorIds",
        isHidden: { statusOption: "No" },
      }
    ),
  ]);

  myForm.addCenteredGroup([myForm.getTextareaField("Description")]);
  return <LmsFormGenerator myForm={myForm} />;
};

const LmsVotingRandomizer = ({ params = {}, history }) => {
  const allowedActions = ["add"];
  const { isMainPage, isAdd, isActionAllowed } = useParseRouteActions(
    params,
    allowedActions
  );
  
  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <LmsVotingRandomizerMainPage />}
      {isAdd && <AddForm />}
    </>
  );
};

export default LmsVotingRandomizer;